import React from "react";
// début de modification Kani
import ReactEcharts from "echarts-for-react";
// fin de modification Kani

/*
import {
    XYPlot,
    YAxis,
    XAxis,
    HorizontalGridLines,
    LineSeries,
    makeVisFlexible,
  } from "react-vis";
*/

function GraphMarges({dataPrix, dataCharges, maximum, minimum, print}) {
  // début de modification Kani
  const widthLigne = print ? 3 : 5;
  const fontSizeLegend = print ? 16 : 18;

  const option = {
    animation: false,
    grid: { left: 70, right: 20, top: 20, bottom: 40, containLabel: true },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: dataPrix.map((p) => p.x),
      axisLabel: { color: "#000", fontSize: fontSizeLegend },
    },
    yAxis: {
      type: "value",
      min: minimum,
      max: maximum,
      axisLabel: {
        color: "#000",
        fontSize: fontSizeLegend,
        formatter: (v) => v / 1000,
      },
      splitLine: { lineStyle: { color: "#AFAFAF" } },
    },
    series: [
      {
        name: "Prix",
        type: "line",
        smooth: true,
        showSymbol: false,
        data: dataPrix.map((p) => [p.x, p.y]),
        lineStyle: { color: "#3075FF", width: widthLigne },
      },
      {
        name: "Charges",
        type: "line",
        smooth: true,
        showSymbol: false,
        data: dataCharges.map((p) => [p.x, p.y]),
        lineStyle: { color: "#FFA366", width: widthLigne },
      },
    ],
  };

  return (
    <div style={{ marginTop: "0px" }}>
      <ReactEcharts
        option={option}
        style={{ height: print ? "300px" : "400px", width: "100%" }}
      />
    </div>
  );
  // fin de modification Kani

  /*
  const FlexXYPlot=makeVisFlexible(XYPlot)
  const yDomain= [minimum,maximum]
  const yAxisOn0 = true
  return (
    <div style={{marginTop:'0px'}}>
      <FlexXYPlot  height={print? 300 : 400} {...{ yDomain}}>
          <YAxis
              tickFormat={v => v/1000}
              style={{ line: {stroke:'grey'}, text: {stroke: 'none', fill: 'black', fontWeight: 500, fontSize: fontSizeLegend} }}
              on0={yAxisOn0}
          />
          <XAxis style={{ text: {stroke: 'none', fill: 'black', fontWeight: 500, fontSize: fontSizeLegend} }} />
          <HorizontalGridLines  style={{stroke: '#AFAFAF'}}  />
          <LineSeries className="prix" curve={'curveMonotoneX'} style={{stroke: '#3075FF', strokeWidth: widthLigne, fill:'transparent' }} data={dataPrix} />
          <LineSeries className="charges" curve={'curveMonotoneX'} style={{stroke: '#FFA366', strokeWidth: widthLigne, fill:'transparent' }} data={dataCharges} />
      </FlexXYPlot>
    </div>
  );
  */
}

export default GraphMarges;
  